import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchSberBinding } from "../../../api/requests/sber";
export var fetchBindingThunk = createAsyncThunk('sber/fetchBinding', fetchSberBinding);